import { createTheme } from "@mui/material/styles";

export const COLORS = {
    WHITE: "#FFFFFF",
    BACKGROUND: "#FCFCF7",
    BACKGROUND_SHADED: "#F4F4F0",
    FUTURE_BLACK: "#000000",
    FUTURE_RED: "#aa1124",
    SB_GREY: "#525252",
    SB_LIGHT_GREY: "#EBF0F5",
    SB_MIDNIGHT: "#071630",
    SB_BLUE: "#1570EF",
    SB_MINT: "#15F2A3",
    BLACK: "#000000",
};

export const theme = createTheme({
    palette: {
        primary: {
            main: COLORS.SB_MIDNIGHT,
        },
        secondary: {
            main: COLORS.SB_BLUE,
        },
        background: {
            default: COLORS.BACKGROUND,
        },
        text: {
            primary: COLORS.SB_GREY,
        },
    },
    typography: {
        fontFamily: "'SK Modernist', system-ui, sans-serif",
        fontSize: 16,
        h1: {
            fontFamily: "'Playfair Display', serif",
            fontSize: 48,
        },
    },
    components: {
        MuiButton: {
            styleOverrides: {
                root: {
                    textTransform: "none",
                },
            },
        },
        MuiAppBar: {
            styleOverrides: {
                colorInherit: {
                    backgroundColor: COLORS.BACKGROUND,
                },
            },
        },
    },
});
